import { useTranslate } from "@similarweb/i18n-provider";

import ManagementCardListItem from "app/pages/sales-intelligence/modules/manage-integrations/components/cards-components/ManagementCardListItem";
import ManagementCardTextBody from "app/pages/sales-intelligence/modules/manage-integrations/components/cards-components/ManagementCardTextBody";
import { StyledManagementCardContentList } from "app/pages/sales-intelligence/modules/manage-integrations/components/cards-components/styles";
import EnrichmentHSStatus from "app/pages/sales-intelligence/modules/manage-integrations/containers/EnrichmentStatusInfoContainers/EnrichmentHSStatusInfo";
import EnrichmentSFStatus from "app/pages/sales-intelligence/modules/manage-integrations/containers/EnrichmentStatusInfoContainers/EnrichmentSFStatusInfo";
import useCrmEnrichmentQuota from "app/pages/sales-intelligence/modules/quota/hooks/useCrmEnrichmentQuota";
import { MANAGEMENT_BODY_TEXTS } from "app/pages/sales-intelligence/pages/management/translations/integrationsKeys";
import {
    MANAGEMENT_ENRICHMENT_PLAIN_TITLE,
    MANAGEMENT_EXCLUSION_INFO_OFF,
    MANAGEMENT_EXCLUSION_INFO_ON,
    MANAGEMENT_EXPORT_TO_CRM_SHORT_TITLE,
    MANAGEMENT_IMPORT_FROM_CRM_SHORT_TITLE,
} from "app/pages/sales-intelligence/pages/management/translations/managementKeys";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import type { IntegrationStatus } from "app/pages/sales-intelligence/sub-modules/management/components/types";
import type { CrmImportSetting, Integration } from "app/pages/sales-intelligence/sub-modules/management/types";

import { CRM_INTEGRATION_EMPTY_TEXT } from "../../../constants/crm";

interface IProps {
    isConnected: boolean;
    isExclusionOn: boolean;
    isExportContactsOn: boolean;
    isExportLeadsOn: boolean;
    isExportAccountsOn: boolean;
    integrationName: Integration;
    statusData?: IntegrationStatus;
    activeImportSettings: CrmImportSetting[];
}

export const CRMIntegrationCardBody = ({
    integrationName,
    isConnected,
    statusData,
    isExclusionOn,
    isExportContactsOn,
    isExportAccountsOn,
    isExportLeadsOn,
    activeImportSettings,
}: IProps) => {
    const { translate } = useTranslate();
    const { isAvailableHubspotEnrichment, isAvailableSalesforceEnrichment } = useCrmEnrichmentQuota();

    const isImportToSimilarwebOn = activeImportSettings.length > 0;
    const isExportToCRMOn = [isExportContactsOn, isExportAccountsOn, isExportLeadsOn].some((isOn) => isOn);

    return isConnected && statusData ? (
        <StyledManagementCardContentList>
            {salesSettingsHelper.isCrmListEnabled() ? (
                <ManagementCardListItem title={translate(MANAGEMENT_IMPORT_FROM_CRM_SHORT_TITLE)}>
                    {translate(isImportToSimilarwebOn ? MANAGEMENT_EXCLUSION_INFO_ON : MANAGEMENT_EXCLUSION_INFO_OFF)}
                </ManagementCardListItem>
            ) : (
                <ManagementCardListItem title={translate(MANAGEMENT_BODY_TEXTS[integrationName].exclusion)}>
                    {translate(isExclusionOn ? MANAGEMENT_EXCLUSION_INFO_ON : MANAGEMENT_EXCLUSION_INFO_OFF)}
                </ManagementCardListItem>
            )}

            <ManagementCardListItem title={translate(MANAGEMENT_EXPORT_TO_CRM_SHORT_TITLE)}>
                {translate(isExportToCRMOn ? MANAGEMENT_EXCLUSION_INFO_ON : MANAGEMENT_EXCLUSION_INFO_OFF)}
            </ManagementCardListItem>

            {integrationName === "salesforce" && isAvailableSalesforceEnrichment ? (
                <ManagementCardListItem title={translate(MANAGEMENT_ENRICHMENT_PLAIN_TITLE)}>
                    <EnrichmentSFStatus />
                </ManagementCardListItem>
            ) : null}
            {integrationName === "hubspot" && isAvailableHubspotEnrichment ? (
                <ManagementCardListItem title={translate(MANAGEMENT_ENRICHMENT_PLAIN_TITLE)}>
                    <EnrichmentHSStatus />
                </ManagementCardListItem>
            ) : null}
        </StyledManagementCardContentList>
    ) : (
        <ManagementCardTextBody>{translate(CRM_INTEGRATION_EMPTY_TEXT[integrationName])}</ManagementCardTextBody>
    );
};
